import { useEffect, useState } from "react"
import gateway from "../../api";
import axios from "axios";
import ReactQuill from "react-quill";

export default function PromotionSection() {
    const [promo, setPromo] = useState(null)

    const fetchPromotion = () => {

        axios
            .get(`${gateway()}/api/business-info/promo/`)
            .then(res => {

                setPromo(res.data)
            })
            .catch(err => { console.error("promo info error : ", err); });
    };

    useEffect(() => {
        fetchPromotion()
    }, [])

    return <div
        className="relative min-h-96 flex flex-col md:flex-row gap-8 items-center px-[20px] lg:px-[80px] py-9"
        style={{
            backgroundImage: `linear-gradient(to bottom, rgba(251,252,253,1), rgba(255,255,255,0.2), rgba(248,250,252,1)), url(images/hero.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}>
        <div className="p-5 w-full lg:w-fit rounded-2xl backdrop-blur-[2px] border-2 border-solid shadow-[0px_0px_6px_0px_rgba(0,_0,_0,_0.1)] border-gray-50 bg-white/60 h-[100%]">
            <div className="text-lg md:text-2xl text-gray-700 text-right font-bold">
                {promo?.promoTitle}
            </div>
            <ReactQuill
                value={promo?.promoDesc}
                readOnly={true}
                theme={"snow"}
                style={{ border: "none" }}
                modules={{
                    toolbar: false,
                    clipboard: {

                    }
                }}
            />

        </div>
        <div className="lg:flex justify-end flex-1 hidden ">
            <img src={promo && promo.promoImage ? `${gateway()}${promo.promoImage}` : ""} className=" shadow-md" style={{ width: "75%" }} alt="busiknow office" />
        </div>
    </div>

}